<template>
    <div class="chat">
      <b-modal centered v-model="showModalMessages" ref="messages-history">
        <div class="col-12 pt-3 pb-3 pl-4">
          <h3><i class="fa fa-comments"></i> Mensagem</h3>
        </div>
        <div class="modal-content">
          <ChatMessages v-show="showModalMessages" ref="chatMessages" :messages="messages" />
        </div>
        <template #modal-footer>
          <div class="w-100 text-right">
            <button type="button" class="btn btn-third btn-sm" @click="closeModal" v-b-tooltip.hover :title="'OK'">
              <i class="fa "></i><span class="d-md-down-none">Ok</span>
            </button>
          </div>
        </template>
      </b-modal>
    </div>
  </template>

<script>
import ChatMessages from '@/views/private/atendimento/components/chat/ChatMessages.vue'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'

export default {
  components: {
    ChatMessages
  },
  data () {
    return {
      showModalMessages: false,
      messages: []
    }
  },
  methods: {
    async openAttachModalMessages (conversationId) {
      if (conversationId) {
        await this.getMessages(conversationId)
        this.showModalMessages = true
      }
    },
    async getMessages (conversationId) {
      try {
        const response = await AtendimentoRepository.GetConversationMessages(conversationId)
        const { data } = response
        this.messages = (data && data.length > 0) ? data.map((message, index) => ({
          ...message,
          sent: true,
          order: index
        })) : []
      } catch (error) {
        console.error(error)
      }
    },
    closeModal () {
      this.showModalMessages = false
    }
  }
}
</script>

  <style lang="scss" scoped>
  .modal-content {
    width: 100%;
    height: 400px;
    overflow-y: auto;
  }
  </style>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/details/components/ChatModal.vue